module.exports = __webpack_public_path__ + "assets/error-e564e8.svg";